import { TZDate } from '@date-fns/tz';
import { format, isValid } from 'date-fns';

import { SERVICE_TIME_ZONE } from '@shared/lib/date';
import { EMPTY_PLACEHOLDER } from '@shared/lib/format';

/** 알린 시각: YY.MM.DD HH:MM(서비스 시간대) */
export function formatNotifiedAt(value: string): string {
  const zoned = new TZDate(value, SERVICE_TIME_ZONE);
  return isValid(zoned) ? format(zoned, 'yy.MM.dd HH:mm') : EMPTY_PLACEHOLDER;
}
